// Registers the Sakhi Didi service worker so the kiosk keeps working
// when the classroom internet drops. Silent no-op in dev.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // CRA sets NODE_ENV to "production" only for `yarn build`. We enable the SW
  // in production and also when explicitly opted in via env, so preview builds
  // hosted through supervisor still work.
  const enabled =
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENABLE_SW === "true";
  if (!enabled) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Auto-activate updates
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        // ignore — offline fallback still works via cached shell
      });
  });
}
